import { ReactElement } from 'react';
import { Environments } from 'types/environment';

export enum Brand {
  Anacapri = 'anacapri',
  Arezzo = 'arezzo',
  Birman = 'birman',
  Fiever = 'fiever',
  Owme = 'owme',
  Schutz = 'schutz',
  Vans = 'vans',
  Vicenza = 'vicenza',
}

export type BrandProperties = {
  code: string;
  displayName: string;
  shortName: string;
  icon: ReactElement;
  url: Record<Environments, string>;
};
